import { getField } from 'vuex-map-fields';
import MediaCategories from '~/services/content/media_categories';

export default {
    getField,

    showIsComarketable: state => {
        return (state.media.is_comarketable == 1 && (state.media.media_category == MediaCategories.PRINT));
    },

    isPublished: (state) => {
        return (state.media.status == 1);
    },

    isPrintContent: state => {
        return (state.media.media_category == MediaCategories.PRINT);
    },

    hasBleedPresets: state => {
        if (state.media.dimensions === undefined || state.media.dimensions.bleeds === undefined) {
            return false;
        }

        return (state.media.dimensions.bleeds.length > 0);
    }

}
